// import { MenuItem, FormControl, InputLabel, Select, Box } from "@material-ui/core";
import {
  MenuItem,
  // OutlinedInput,
  // InputLabel,
  // FormControl,
  // ListItemText,
  // Checkbox,
  Select,
  // Chip,
  // Box,
} from "@material-ui/core";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import api from "../../../../../config/api";
import { useAuth } from "../../../../../context/ContextApi";
import { useCallback } from "react";
import { useEffect } from "react";

const SelectHoursFood = ({ handleNewReserve, index, date, reserve, error }) => {
  const { userEstablishment } = useAuth();
  const [hour, setHour] = useState(reserve?.hour || "");
  const [options, setOptions] = useState([]);
  const getHourReserve = async () => {
    if (!date) return;
    const response = await api.get(`/establishment-reserves/?establishment=${userEstablishment}&date=${date}`);
    setOptions(() => response.data.hours);
  };

  useEffect(() => {
    getHourReserve();
  }, [date]);

  const handleType = (event) => {
    setHour(event.target.value);
    handleNewReserve(event);
  };
  return (
    <>
      <div className="d-flex mb-4 ">
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label" style={{ paddingTop: "5px" }}>
            Hora
          </InputLabel>
          <Select
            error={error}
            required
            MenuProps={{
              variant: "menu",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            }}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="hour"
            value={hour}
            label="Serviços"
            onChange={handleType}
            input={<OutlinedInput label="label" className="fz-16 text-cl-dark-jungle-green ff-univanova pt-1" />}
          >
            {options.map((hour) => (
              <MenuItem key={hour} value={hour}>
                {hour}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </>
  );
};

export default SelectHoursFood;
